import { useElementVisibility } from "@vueuse/core";
import type { LeafletConf } from "~~/models/Leaflet";
const leafletConf: Ref<LeafletConf | null> = ref(null);

export const startDeath = () => {
    if (leafletConf.value && leafletConf.value.sideEffectRef) {
        clearTimeout(leafletConf.value.incubationPhase);
        leafletConf.value.dying = setTimeout(() => {
            if (leafletConf.value) {
                leafletConf.value.showing = false;
                if (leafletConf.value?.visibilityWatcher) {
                    leafletConf.value?.visibilityWatcher();
                };
            }
        }, 100);
    }
};

export const showLeaflet = (sideEffect: HTMLElement, leafletText: string) => {
    const hasContent = !!leafletText;
    if (hasContent) {
        clearTimeout(leafletConf.value?.dying);

        if (leafletConf?.value?.visibilityWatcher) {
            leafletConf?.value?.visibilityWatcher();   
        }

        if (sideEffect !== leafletConf.value?.sideEffectRef) {
            sideEffect?.addEventListener('mouseleave', startDeath);
        }

        const config = {
            sideEffectRef: sideEffect,
            cured: useElementVisibility(shallowRef(sideEffect)),
            content: leafletText,
            xPos: sideEffect.getBoundingClientRect().left,
            yPos: sideEffect.getBoundingClientRect().bottom,
        } as LeafletConf;
        leafletConf.value = config;
        leafletConf.value.incubationPhase = setTimeout(() => {
            if (leafletConf.value) {
                leafletConf.value.showing = true;
            }
        }, 300);

        if (leafletConf?.value?.cured !== undefined) {
            leafletConf.value.visibilityWatcher = watch(() => leafletConf?.value?.cured, () => {
                if (!leafletConf?.value?.cured) {
                    startDeath();
                }
            })   
        }
    }
};

export const getLeafletConf = (): Ref<LeafletConf | null> => {
    return leafletConf;
};

export const keepAlive = () => {
    clearTimeout(leafletConf.value?.dying);
};
